// Español de Chile (tuteo). Es el diccionario base: toda clave existe aquí.
const esCL = {
  // Comunes
  "common.loading": "Cargando…",
  "common.back": "Volver",
  "common.continue": "Continuar",
  "common.start": "Comenzar",
  "common.review": "Revisar",
  "common.watchAgain": "Volver a ver",
  "common.read": "Leer",
  "common.understood": "Entendido",
  "common.retry": "Intentar de nuevo",
  "common.save": "Guardar",
  "common.saving": "Guardando…",
  "common.close": "Cerrar",
  "common.demo": "Entorno de demostración · datos ficticios",
  "common.language": "Idioma",

  // Navegación
  "nav.home": "Inicio",
  "nav.dashboard": "Dashboard",
  "nav.profile": "Perfil",
  "nav.certificates": "Mis certificados",
  "nav.logout": "Cerrar sesión",
  "nav.openMenu": "Abrir menú",
  "nav.lesson": "Lección",
  "nav.learningWorlds": "Mundos de aprendizaje",
  "nav.controlPanel": "Panel de control",
  "nav.badges": "Medallas alcanzadas",
  "nav.seeBadges": "Ver mis medallas",

  // Login
  "login.title": "Iniciar sesión",
  "login.email": "Correo",
  "login.password": "Contraseña",
  "login.submit": "Ingresar",
  "login.noAccount": "¿No tienes cuenta?",
  "login.register": "Regístrate",
  "login.general": "Ir al login general",
  "login.orgNotFound": "Organización no encontrada",
  "login.error": "No pudimos iniciar sesión. Revisa tu correo y contraseña.",
  "login.googleError": "No pudimos iniciar sesión con Google.",
  "login.goToOrg": "Ir al login de {org}",
  "login.yourOrg": "tu organización",

  // Inicio / rutas
  "home.welcome": "Bienvenido a {org}",
  "home.noChallenges": "Aún no tienes rutas asignadas.",
  "home.myChallenges": "Mis desafíos",
  "home.pick": "Selecciona una ruta para comenzar tu experiencia de aprendizaje.",
  "home.pickOrg": "{org}: selecciona una ruta para comenzar tu experiencia de aprendizaje.",
  "home.loading": "Cargando datos…",
  "home.loadingHint": "Estamos preparando tu experiencia de aprendizaje.",
  "home.loadingCourse": "Cargando curso…",
  "home.loadingCourseHint": "Estamos trayendo módulos, lecciones y avance actualizado.",
  "home.loadingLessons": "Cargando lecciones…",
  "home.loadingLessonsHint": "Un momento, estamos ordenando el mapa del curso.",
  "home.loadingChallenges": "Cargando cursos disponibles…",
  "home.loadingChallengesHint": "Estamos buscando tus rutas, avance y ranking.",
  "home.courseError": "No pudimos cargar el curso",
  "home.courseErrorHint": "No pudimos cargar el curso. Revisa tu conexión e intenta de nuevo.",
  "home.map": "Mapa de aprendizaje",
  "home.backToChallenges": "Volver a las rutas",
  "home.overallProgress": "Progreso general",
  "home.stages": "{done}/{total} módulos",
  "home.points": "pts",
  "home.lessons": "{done}/{total} lecciones",
  "home.stage": "Módulo",
  "home.locked": "Bloqueado",
  "home.completed": "Completado",
  "home.inProgress": "En curso",
  "home.pending": "Pendiente",
  "home.certifies": "Certifica",

  // Tarjetas de tarea
  "task.startQuiz": "Comenzar evaluación",
  "task.startExercise": "Comenzar ejercicio",
  "task.startSimulation": "Comenzar simulación",
  "task.watch": "Ver",
  "task.minutes": "{n} min",

  // Lección
  "lesson.backHome": "Volver al inicio",
  "lesson.backToMap": "Volver al mapa",
  "lesson.finishTitle": "Finaliza esta lección",
  "lesson.finishHint": "Para avanzar, primero guarda tu avance en la lección actual.",
  "lesson.resourceOf": "Recurso {n} de {total}",
  "lesson.saved": "Tu avance ya quedó guardado.",
  "lesson.saveWhenDone": "Cuando termines la actividad, guarda tu avance.",
  "lesson.saveWhenDoneLong": "Cuando termines la actividad, guarda tu avance para continuar.",
  "lesson.next": "Continúa con el siguiente recurso.",
  "lesson.nextLong": "Continúa con el siguiente recurso de esta lección.",
  "lesson.nextResource": "Continuar recurso",
  "lesson.finish": "Finalizar lección",
  "lesson.rate": "Califica la lección",
  "lesson.rateHint": "Tu aporte nos ayuda a mejorar.",
  "lesson.loading": "Cargando lección",
  "lesson.congrats": "¡Felicidades!",
  "lesson.challengeDone": "¡Felicidades! ¡Completaste la ruta!",
  "lesson.scormActive": "SCORM 1.2 activo",

  // Evaluación
  "exam.title": "Evaluación",
  "exam.loading": "Cargando evaluación…",
  "exam.loadError": "No pudimos cargar esta evaluación. Intenta nuevamente.",
  "exam.sessionError": "No se pudo cargar la evaluación: faltan datos de sesión o ruta.",
  "exam.saveError": "No pudimos guardar el resultado de la evaluación.",
  "exam.passed": "Evaluación aprobada",
  "exam.saved": "Resultado guardado",
  "exam.score": "Obtuviste {correct}/{total} correctas ({pct}%).",
  "exam.needed": "Necesitas al menos {n} respuestas correctas para aprobar. Puedes revisar el contenido e intentarlo nuevamente.",
  "exam.readyToSend": "Todo listo para enviar.",
  "exam.answerAll": "Responde todas las preguntas para enviar la evaluación.",
  "exam.submit": "Enviar evaluación",
  "exam.retry": "Intentar de nuevo",
  "exam.backToMap": "Volver al mapa",
  "exam.question": "Pregunta {n} de {total}",
  "exam.seeCertificate": "Ver mi certificado",
  "exam.passingScoreHint": "Se aprueba con {n} respuestas correctas de {total}.",

  // Certificados
  "cert.title": "Certificado",
  "cert.certifies": "Certifica que",
  "cert.completed": "completó satisfactoriamente",
  "cert.issuedOn": "Emitido el {date}",
  "cert.validUntil": "Vigente hasta {date}",
  "cert.code": "Código de verificación",
  "cert.score": "Nota: {pct}%",
  "cert.print": "Imprimir o guardar PDF",
  "cert.mine": "Mis certificados",
  "cert.none": "Todavía no tienes certificados. Aprueba una evaluación certificable y aparecerá aquí.",
  "cert.view": "Ver certificado",
  "cert.verify": "Verificar en {url}",
  "cert.signedBy": "Firma",
  "cert.expired": "Vencido",
  "cert.valid": "Vigente",
  "cert.expiring": "Por vencer",

  // Perfil
  "profile.myData": "Mis datos",
  "profile.organization": "Organización",
  "profile.badges": "Mis medallas",

  // Tema Aclara (Campus Aclara)
  "aclara.status.done": "Completado",
  "aclara.status.progress": "En curso",
  "aclara.status.pending": "Pendiente",
  "aclara.nav.route": "Mi ruta",
  "aclara.nav.news": "Noticias",
  "aclara.nav.certificates": "Certificados",
  "aclara.nav.dashboard": "Dashboard",
  "aclara.nav.profile": "Perfil",
  "aclara.role.admin": "Administración",
  "aclara.role.collaborator": "Colaborador/a",
  "aclara.footer.campus": "Campus de onboarding",
  "aclara.footer.powered": "Plataforma de aprendizaje Ewaffle",
  "aclara.login.eyebrow": "Onboarding",
  "aclara.login.claim": "Tu primera semana en Aclara empieza aquí.",
  "aclara.login.claimBody": "Seis módulos cortos para conocer la empresa, cómo cuidamos a las personas y al entorno, y cómo trabajamos en equipo. Desde el celular y en tu idioma.",
  "aclara.login.metaModules": "módulos",
  "aclara.login.metaCountries": "países",
  "aclara.login.metaCerts": "certificados",
  "aclara.login.title": "Campus Aclara",
  "aclara.login.welcome": "Ingresa con tu correo corporativo.",
  "aclara.login.or": "o",
  "aclara.home.eyebrow": "Campus",
  "aclara.home.hello": "Hola, {name}",
  "aclara.home.intro": "Tu ruta de onboarding: módulos cortos, dos evaluaciones certificables y un certificado al terminar.",
  "aclara.home.seeRoute": "Ver mi ruta",
  "aclara.home.seeCertificates": "Ver mis certificados",
  "aclara.home.routeDone": "Ruta completada",
  "aclara.home.routeDoneHint": "Terminaste el onboarding. Tus certificados están disponibles.",
  "aclara.home.lessonsDone": "{done} de {total} lecciones",
  "aclara.home.nextIs": "Sigue con: {name}",
  "aclara.home.loadingRoute": "Cargando tu ruta…",
  "aclara.home.modulesEyebrow": "Tu ruta",
  "aclara.home.newsTitle": "Lo último en Aclara",
  "aclara.home.allNews": "Todas las noticias",
  "aclara.home.allCerts": "Ver todos",
  "aclara.news.eyebrow": "Noticia",
  "aclara.news.title": "Noticias",
  "aclara.news.intro": "Novedades de la empresa y de cada país. Lo que publica el equipo de Personas aparece aquí.",
  "aclara.news.none": "Todavía no hay noticias publicadas.",
  "aclara.module.lessonsCount": "{done}/{total} lecciones",
  "aclara.module.certifies": "Certifica",
  "aclara.module.n": "Módulo {n}",
  "aclara.module.notFound": "No encontramos este módulo en tu ruta.",
  "aclara.module.contents": "Contenido del módulo",
  "aclara.module.certHint": "Al aprobar «{title}» recibes un certificado con vigencia de 12 meses. Puedes repetir la evaluación las veces que necesites.",
  "aclara.lesson.kindLesson": "Lección",
  "aclara.lesson.kindExam": "Evaluación",
  "aclara.lesson.notFound": "No encontramos esta lección en tu ruta.",
  "aclara.lesson.noResource": "Esta lección todavía no tiene contenido cargado.",
  "aclara.lesson.status": "Estado",
  "aclara.lesson.scormHint": "El avance se registra solo al terminar el contenido. Si ya lo revisaste completo, márcalo aquí.",
  "aclara.lesson.markDone": "Marcar como completada",
  "aclara.lesson.adminPreview": "Vista de administración: el avance se registra solo para colaboradores.",
  "aclara.lesson.prev": "Anterior",
  "aclara.lesson.next": "Siguiente",
  "aclara.lesson.module": "Ver módulo",
  "aclara.exam.notYet": "Todavía no",
  "aclara.exam.backToRoute": "Volver a mi ruta",
  "aclara.certs.intro": "Los certificados que obtienes al aprobar una evaluación. Cada uno tiene un código que cualquiera puede verificar.",
  "aclara.profile.noBadges": "Todavía no tienes medallas. Completa tu primera lección para ganar la primera.",
  "aclara.dash.openAdmin": "Abrir herramientas de administración",
  "aclara.dash.title": "Avance por {label}",
  "aclara.dash.intro": "Cuántas personas están inscritas, cuántas terminaron la ruta y cuántos certificados se emitieron, por país.",
  "aclara.dash.noSegment": "Sin {label}",
  "aclara.dash.kpiTotal": "Personas",
  "aclara.dash.kpiEnrolled": "Inscritas",
  "aclara.dash.kpiDone": "Completaron",
  "aclara.dash.kpiCerts": "Certificados",
  "aclara.dash.bySegment": "Resumen por {label}",
  "aclara.dash.empty": "Todavía no hay datos para mostrar.",
  "aclara.dash.completion": "Completaron / inscritas",
  "aclara.dash.progressBy": "Avance de la ruta por {label}",
  "aclara.dash.bucket.done": "Completaron",
  "aclara.dash.bucket.mid": "En curso",
  "aclara.dash.bucket.none": "Sin empezar",
  "aclara.dash.people": "{n} personas",
  "aclara.dash.avgProgress": "Avance promedio",
  "aclara.dash.avgGrade": "Nota promedio",
  "aclara.dash.loggedIn": "Han ingresado",
};

export default esCL;
